import { t } from '@lingui/core/macro';
import { isPresent } from '@luminovo/commons';

import { getLocale } from '../i18n';
import { getOrCreateNumberFormatter } from './getOrCreateNumberFormat';

const intlOpts: Intl.NumberFormatOptions = {
    style: 'decimal',
};

export function formatDecimal(
    number?: number | null,
    options?: {
        ifAbsent?: string;
        ifNaN?: string;
        suffix?: string;
        maximumFractionDigits?: number;
        minimumFractionDigits?: number;
        alwaysShowSign?: boolean;
    },
): string {
    const {
        ifAbsent = `-`,
        ifNaN = t`Unknown`,
        suffix = '',
        maximumFractionDigits,
        minimumFractionDigits,
        alwaysShowSign = false,
    } = options || {};

    if (!isPresent(number)) {
        return ifAbsent;
    }

    if (isNaN(number)) {
        return ifNaN ?? ifAbsent;
    }

    const intlOptions: Intl.NumberFormatOptions = {
        ...intlOpts,
        maximumFractionDigits,
        minimumFractionDigits,
        ...(alwaysShowSign ? { signDisplay: 'exceptZero' } : {}),
    };
    return `${getOrCreateNumberFormatter(getLocale(), intlOptions).format(number)}${suffix}`;
}
